module.exports = __webpack_public_path__ + "img/laohuang_des_4.1524a598.jpg";